import React from 'react';
import { Link } from 'react-router-dom';
import './ITServices.css';

/* â"€â"€ Icons â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */
const IconShield    = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>;
const IconCloud     = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M18 10h-1.26A8 8 0 109 20h9a5 5 0 000-10z"/></svg>;
const IconServer    = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="8" rx="2"/><rect x="2" y="14" width="20" height="8" rx="2"/><line x1="6" y1="6" x2="6.01" y2="6"/><line x1="6" y1="18" x2="6.01" y2="18"/></svg>;
const IconCpu       = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><rect x="9" y="9" width="6" height="6"/><line x1="9" y1="1" x2="9" y2="4"/><line x1="15" y1="1" x2="15" y2="4"/><line x1="9" y1="20" x2="9" y2="23"/><line x1="15" y1="20" x2="15" y2="23"/><line x1="20" y1="9" x2="23" y2="9"/><line x1="20" y1="14" x2="23" y2="14"/><line x1="1" y1="9" x2="4" y2="9"/><line x1="1" y1="14" x2="4" y2="14"/></svg>;
const IconMap       = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"/><line x1="8" y1="2" x2="8" y2="18"/><line x1="16" y1="6" x2="16" y2="22"/></svg>;
const IconClipboard = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2"/><rect x="8" y="2" width="8" height="4" rx="1"/></svg>;
const IconTarget    = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>;
const IconBug       = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M8 2l1.88 1.88M16 2l-1.88 1.88M9 7.13v-1a3.003 3.003 0 116 0v1"/><path d="M12 20c-3.3 0-6-2.7-6-6v-3a4 4 0 014-4h4a4 4 0 014 4v3c0 3.3-2.7 6-6 6z"/><path d="M12 20v-9M6.53 9C4.6 8.8 3 7.1 3 5M6 13H2M20 13h-4M20.47 9C22.4 8.8 24 7.1 24 5M12 3a2 2 0 000 4"/></svg>;
const IconActivity  = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>;
const IconUsers     = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"/></svg>;
const IconUpload    = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.4 6.4A9 9 0 103.6 17.6M16 6l-4-4-4 4"/></svg>;
const IconLock      = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>;
const IconSettings  = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg>;
const IconNetwork   = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="16" y="16" width="6" height="6" rx="1"/><rect x="2" y="16" width="6" height="6" rx="1"/><rect x="9" y="2" width="6" height="6" rx="1"/><path d="M5 16v-4h14v4M12 8v4"/></svg>;
const IconHeadset   = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M3 18v-6a9 9 0 0118 0v6"/><path d="M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z"/></svg>;
const IconBot       = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="10" rx="2"/><circle cx="12" cy="5" r="2"/><line x1="12" y1="7" x2="12" y2="11"/><line x1="8" y1="15" x2="8" y2="17"/><line x1="16" y1="15" x2="16" y2="17"/></svg>;
const IconZap       = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>;
const IconLayers    = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 2 7 12 12 22 7 12 2"/><polyline points="2 17 12 22 22 17"/><polyline points="2 12 12 17 22 12"/></svg>;
const IconRefresh   = ({ size = 22 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10"/></svg>;
const IconCheck     = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>;
const IconArrow     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>;

/* â"€â"€ Data â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */
const cyberServices = [
  { icon: <IconMap />,       title: 'Security Strategy',            desc: 'Develop a comprehensive security roadmap aligned to your business objectives and risk tolerance.' },
  { icon: <IconClipboard />, title: 'Compliance & Risk Management', desc: 'Navigate ISO 27001, NIST, SOC 2, and GDPR regulatory requirements with confidence.' },
  { icon: <IconTarget />,    title: 'Threat Risk Assessment',       desc: 'Identify, evaluate, and prioritize risks across your entire digital environment.' },
  { icon: <IconBug />,       title: 'Vulnerability & Pen Testing',  desc: 'Proactive identification of weaknesses before adversaries can exploit them.' },
  { icon: <IconActivity />,  title: 'Threat Detection & Response',  desc: 'Real-time monitoring, detection, and coordinated incident response capabilities.' },
  { icon: <IconUsers />,     title: 'Cyber Security Awareness',     desc: 'Human-layer defense through targeted training and phishing simulation programs.' },
];

const cloudServices = [
  { icon: <IconUpload />,   title: 'Cloud Migration & Integration', providers: ['AWS', 'Azure', 'GCP', 'OCI'], desc: 'Seamless transition of workloads with zero-downtime migration strategies and post-migration optimization.' },
  { icon: <IconLock />,     title: 'Cloud Security',               providers: ['IAM', 'CSPM', 'CWPP'],       desc: 'Architecture reviews, identity management, data encryption, and continuous cloud threat monitoring.' },
  { icon: <IconSettings />, title: 'Managed Cloud Services',       providers: ['FinOps', 'SRE', '24/7 NOC'], desc: 'Ongoing operations, performance optimization, and security management as a fully managed service.' },
];

const infraCards = [
  { icon: <IconHeadset />, title: 'IT Consulting',          img: '/images/it-services/it-consulting.jpg',           desc: 'Strategic technology advice to align your IT investments with business growth objectives and long-term vision.' },
  { icon: <IconNetwork />, title: 'Network Infrastructure', img: '/images/it-services/network-infrastructure.jpg',  desc: 'Design, deployment, and management of secure, high-performance network environments built for scale.' },
  { icon: <IconServer />,  title: 'End-to-End IT Support',  img: '/images/it-services/it-support.jpg',              desc: 'Comprehensive support services covering hardware, software, and user productivity across your organization.' },
];

const aiCapabilities = [
  { n: '01', icon: <IconCpu />,      title: 'AI Workflow Integration',      desc: 'Embed AI directly into your existing business processes - automating tasks and surfacing insights where your team already works.' },
  { n: '02', icon: <IconBot />,      title: 'Agentic AI Solutions',         desc: 'Autonomous agents that reason, plan, and act across systems, handling complex multi-step tasks on your behalf.' },
  { n: '03', icon: <IconZap />,      title: 'Web & Process Automation',     desc: 'Intelligent automation across web applications, internal portals, and back-office workflows at scale.' },
  { n: '04', icon: <IconLayers />,   title: 'Enterprise AI Platform',       desc: 'A unified platform for deploying, managing, and governing AI models with enterprise-grade security controls.' },
  { n: '05', icon: <IconRefresh />,  title: 'Continuous AI Optimization',   desc: 'Model monitoring, retraining pipelines, and benchmarking to keep your AI investments improving over time.' },
  { n: '06', icon: <IconSettings />, title: 'Custom Model Development',     desc: 'Fine-tuned models trained on your proprietary data delivering domain-specific intelligence.' },
];

const eapFeatures = [
  'Centralized model registry & versioning',
  'Role-based access & audit trails',
  'Multi-LLM orchestration (GPT, Claude, Gemini)',
  'Agentic workflow builder - no-code & pro-code',
  'Real-time usage dashboards & cost controls',
  'On-premise or private cloud deployment',
];

const processSteps = [
  { n: '01', title: 'Assess',     desc: 'We audit your current environment to identify gaps, risks, and opportunities.' },
  { n: '02', title: 'Strategize', desc: 'A tailored roadmap is built around your business goals and compliance needs.' },
  { n: '03', title: 'Deploy',     desc: 'Certified experts implement and integrate solutions with minimal disruption.' },
  { n: '04', title: 'Monitor',    desc: 'Continuous monitoring, reporting, and iteration to keep you always protected.' },
];

const stats = [
  { value: '500+', label: 'Clients Served' },
  { value: '99.9%', label: 'Uptime SLA' },
  { value: '24/7', label: 'SOC Monitoring' },
  { value: '15+', label: 'Years of Experience' },
];

/* â"€â"€ Component â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */
export default function ITServices() {
  return (
    <div className="its-page">

      {/* â"€â"€â"€ HERO â"€ full-bleed image, centred editorial â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */}
      <section className="its-hero" style={{ backgroundImage: "url('/images/it-services/cyber-security.jpg')" }}>
        <div className="its-hero-overlay" />
        <div className="container its-hero-inner">
          <span className="section-label section-label--blue">Enterprise Technology Services</span>
          <h1 className="its-hero-h1">
            Protecting &amp; Powering<br />
            <span className="its-hero-grad">Your Business</span>
          </h1>
          <p className="its-hero-sub">
            End-to-end IT and cybersecurity services built for enterprise scale - threat detection, cloud transformation, infrastructure management, and AI implementation.
          </p>
          <div className="its-hero-actions">
            <Link to="/contact" className="its-btn-primary">Get a Free Consultation <IconArrow /></Link>
            <a href="#its-services" className="its-btn-outline">Explore Services</a>
          </div>
          <div className="its-hero-badges">
            <span className="its-badge"><IconCheck /> ISO 27001</span>
            <span className="its-badge"><IconCheck /> SOC 2 Ready</span>
            <span className="its-badge"><IconCheck /> NIST Framework</span>
          </div>
        </div>
        <div className="its-anchors" id="its-services">
          <div className="container its-anchors-row">
            {[
              { icon: <IconShield size={18} />, label: 'Cyber Security',    href: '#cyber' },
              { icon: <IconCloud size={18} />,  label: 'Cloud Solutions',   href: '#cloud' },
              { icon: <IconServer size={18} />, label: 'IT Infrastructure', href: '#infra' },
              { icon: <IconCpu size={18} />,    label: 'Enterprise AI',     href: '#ai'    },
            ].map((a, i) => (
              <a href={a.href} className="its-anchor-pill" key={i}>
                <span className="its-anchor-icon">{a.icon}</span>
                {a.label}
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* â"€â"€â"€ 01 CYBER SECURITY â"€ section-labelled, card grid â"€â"€â"€â"€â"€â"€â"€â"€ */}
      <section className="its-sec its-sec--white" id="cyber">
        <div className="container">
          <div className="its-sec-label-row">
            <span className="section-label section-label--blue">Cyber Security</span>
          </div>
          <div className="its-sec-heading-row">
            <h2 className="its-sec-h2">Comprehensive <span>Cyber Defense</span></h2>
            <p className="its-sec-desc">
              End-to-end cybersecurity services from strategic planning to real-time threat detection. We protect your organization across every attack surface - people, processes, and technology.
            </p>
          </div>
          <div className="its-cyber-grid">
            {cyberServices.map((s, i) => (
              <div className="its-cyber-card" key={i}>
                <div className="its-card-icon">{s.icon}</div>
                <h4>{s.title}</h4>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* â"€â"€â"€ 02 CLOUD SOLUTIONS â"€ dark bg, horizontal feature rows â"€â"€ */}
      <section className="its-sec its-sec--dark" id="cloud">
        <div className="container">
          <div className="its-sec-heading-row its-heading-row--split">
            <div>
              <span className="section-label section-label--blue">Cloud Solutions</span>
              <h2 className="its-sec-h2 its-h2--white">Secure Cloud <span className="its-orange">Transformation</span></h2>
            </div>
            <p className="its-sec-desc its-desc--muted">
              Accelerate your cloud journey while maintaining security, compliance, and operational efficiency across multi-cloud and hybrid environments.
            </p>
          </div>
          <div className="its-cloud-body">
            <div className="its-cloud-img-col">
              <img src="/images/it-services/cloud-solutions.jpg" alt="Cloud solutions" />
            </div>
            <div className="its-cloud-rows">
              {cloudServices.map((s, i) => (
                <div className="its-cloud-row" key={i}>
                  <div className="its-card-icon its-card-icon--dark">{s.icon}</div>
                  <div className="its-cloud-row-body">
                    <h4>{s.title}</h4>
                    <p>{s.desc}</p>
                    <div className="its-cloud-row-tags">
                      {s.providers.map(p => <span key={p}>{p}</span>)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* â"€â"€â"€ 03 IT INFRASTRUCTURE â"€ side header + image cards â"€â"€â"€â"€â"€â"€â"€â"€ */}
      <section className="its-sec its-sec--cream" id="infra">
        <div className="container">
          <div className="its-sec-heading-row its-heading-row--split">
            <div>
              <span className="section-label section-label--blue">IT Infrastructure</span>
              <h2 className="its-sec-h2">Robust IT <span>Infrastructure</span></h2>
            </div>
            <p className="its-sec-desc">
              Build, optimize, and secure your IT foundation. From network design to end-user support, we deliver reliable technology that scales with your business.
            </p>
          </div>
          <div className="its-infra-grid">
            {infraCards.map((card, i) => (
              <div className="its-infra-card" key={i}>
                <div className="its-infra-img">
                  <img src={card.img} alt={card.title} />
                </div>
                <div className="its-infra-body">
                  <div className="its-card-icon">{card.icon}</div>
                  <h3>{card.title}</h3>
                  <p>{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="its-sla-row">
            {['99.9% SLA Uptime', 'Certified Engineers', '24/7 Help Desk', 'Proactive Maintenance'].map(item => (
              <div className="its-sla-item" key={item}><span className="its-check-dot"><IconCheck /></span>{item}</div>
            ))}
          </div>
        </div>
      </section>

      {/* â"€â"€â"€ 04 ENTERPRISE AI â"€ numbered list + dark EAP panel â"€â"€â"€â"€â"€â"€â"€â"€ */}
      <section className="its-sec its-sec--white" id="ai">
        <div className="container">
          <div className="its-sec-label-row">
            <span className="section-label section-label--blue">Enterprise AI</span>
          </div>
          <div className="its-sec-heading-row">
            <h2 className="its-sec-h2">Intelligent Automation &amp; <span>AI Implementation</span></h2>
            <p className="its-sec-desc">
              We embed AI directly into your workflows - from autonomous agents to a full enterprise platform that governs, scales, and secures AI adoption across your organization.
            </p>
          </div>
          <div className="its-ai-layout">
            <div className="its-ai-caps">
              {aiCapabilities.map((c, i) => (
                <div className="its-ai-row" key={i}>
                  <div className="its-ai-row-left">
                    <div className="its-card-icon">{c.icon}</div>
                  </div>
                  <div className="its-ai-row-body">
                    <h4>{c.title}</h4>
                    <p>{c.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="its-eap-panel">
              <img src="/images/it-services/ai-implementation.jpg" alt="AI platform" className="its-eap-img" />
              <div className="its-eap-content">
                <div className="its-eap-header">
                  <div className="its-card-icon"><IconCpu /></div>
                  <div>
                    <div className="its-eap-name">Enterprise AI Platform</div>
                    <div className="its-eap-sub">EAP by ThirdEye</div>
                  </div>
                </div>
                <h4 className="its-eap-title">One Platform. All Your AI - Governed &amp; Scalable.</h4>
                <ul className="its-eap-list">
                  {eapFeatures.map(f => (
                    <li key={f}><span className="its-check-dot"><IconCheck /></span>{f}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* â"€â"€â"€ PROCESS â"€ connected timeline â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */}
      <section className="its-process">
        <div className="container">
          <div className="its-process-head">
            <span className="section-label section-label--blue">Our Approach</span>
            <h2 className="its-sec-h2 its-h2--white">How We <span className="its-orange">Deliver</span></h2>
          </div>
          <div className="its-timeline">
            {processSteps.map((step, i) => (
              <div className="its-timeline-step" key={i}>
                <div className="its-timeline-node">
                  <span>{step.n}</span>
                </div>
                {i < processSteps.length - 1 && <div className="its-timeline-line" />}
                <div className="its-timeline-content">
                  <h4>{step.title}</h4>
                  <p>{step.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* â"€â"€â"€ CTA â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€â"€ */}
      <section className="its-cta-wrap">
        <div className="container">
          <div className="cta-inner">
            <div className="cta-glow" />
            <div className="cta-content">
              <h2>Let Us Build a Stronger Security Posture Together</h2>
              <p>Whether you are facing resource constraints, launching a new project, or strengthening your security measures - ThirdEye has the expertise to help.</p>
              <div className="cta-actions">
                <Link to="/staff-augmentation" className="btn-outline-white">Staff Augmentation</Link>
                <Link to="/contact" className="btn-primary">Start a Conversation <IconArrow /></Link>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

